import { Entity, Location, OptimizerConfig, TrafficOptions } from '@nx-smartmonkey/shared/domain';
import { removeEmpty } from '@nx-smartmonkey/shared/helpers';
import { ProjectCustomFields } from '../../project/ProjectCustomFields';

import { GeoFence } from '../../geoFence/GeoFence';
import { ProjectUnits } from '../../project/ProjectUnits';
import { ProjectConstraints } from '../../project/projectConstraints/ProjectConstraints';
import { ProjectCustomerEmail } from '../../project/projectCustomerEmail/ProjectCustomerEmail';
import { ProjectCustomerSMS } from '../../project/projectCustomerSMS/ProjectCustomerSMS';
import { ProjectCustomerWhatsApp } from '../../project/projectCustomerWhatsApp/ProjectCustomerWhatsApp';
import { ProjectResources } from './ProjectResources';

export interface UpdateProjectBaseProps {
  label?: string | null;
  description?: string | null;
  location?: Location | null;
  optimizer_config?: OptimizerConfig;
  traffic_options?: TrafficOptions;
  units?: ProjectUnits;
  tasks_enabled?: boolean;
  geo_fences_enabled?: boolean;
}

export interface ProjectBaseProps {
  organization_id: string;
  label?: string;
  public_key?: string;
  location?: Location;
  description?: string;
  avatar_url?: string;
  optimizer_config?: OptimizerConfig;
  traffic_options?: TrafficOptions;
  units?: ProjectUnits;

  custom_fields?: ProjectCustomFields;
  customer_email: ProjectCustomerEmail;
  customer_sms: ProjectCustomerSMS;
  customer_whatsapp: ProjectCustomerWhatsApp;

  tasks_enabled: boolean;
  geo_fences_enabled: boolean;
  constraints: ProjectConstraints;

  geo_fences: GeoFence[];

  managed: boolean;

  resources: ProjectResources;

  deleted?: boolean;
  created_by: string;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
}

export class ProjectBase extends Entity<ProjectBaseProps> {
  private _avatar: string | undefined;

  get id(): string {
    return this._id!;
  }
  get organization_id(): string {
    return this.props.organization_id;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  set label(label: string | undefined) {
    this.props.label = label;
  }
  get public_key(): string | undefined {
    return this.props.public_key;
  }
  get location(): Location | undefined {
    return this.props.location;
  }
  set location(location: Location | undefined) {
    this.props.location = location;
  }
  get description(): string | undefined {
    return this.props.description;
  }
  set description(description: string | undefined) {
    this.props.description = description;
  }
  get avatar_url(): string | undefined {
    return this.props.avatar_url;
  }
  set avatar_url(avatar_url: string | undefined) {
    this.props.avatar_url = avatar_url;
  }
  get project_avatar(): string | undefined {
    return this._avatar;
  }
  set project_avatar(project_avatar: string | undefined) {
    this._avatar = project_avatar;
  }
  get optimizer_config(): OptimizerConfig | undefined {
    return this.props.optimizer_config;
  }
  set optimizer_config(optimizer_config: OptimizerConfig | undefined) {
    this.props.optimizer_config = optimizer_config;
  }
  get traffic_options(): TrafficOptions | undefined {
    return this.props.traffic_options;
  }
  set traffic_options(traffic_options: TrafficOptions | undefined) {
    this.props.traffic_options = traffic_options;
  }
  get units(): ProjectUnits | undefined {
    return this.props.units;
  }
  set units(units: ProjectUnits | undefined) {
    this.props.units = units;
  }
  get custom_fields(): ProjectCustomFields | undefined {
    return this.props.custom_fields;
  }
  get customer_email(): ProjectCustomerEmail {
    return this.props.customer_email;
  }
  get customer_sms(): ProjectCustomerSMS {
    return this.props.customer_sms;
  }
  get customer_whatsapp(): ProjectCustomerWhatsApp {
    return this.props.customer_whatsapp;
  }
  get tasks_enabled(): boolean {
    return this.props.tasks_enabled;
  }
  set tasks_enabled(tasks_enabled: boolean) {
    this.props.tasks_enabled = tasks_enabled;
  }
  get geo_fences_enabled(): boolean {
    return this.props.geo_fences_enabled;
  }
  get geo_fences(): GeoFence[] {
    return this.props.geo_fences;
  }
  set geo_fences(geo_fences: GeoFence[]) {
    this.props.geo_fences = geo_fences;
  }
  get constraints(): ProjectConstraints {
    return this.props.constraints;
  }
  get managed(): boolean {
    return this.props.managed;
  }
  get resources(): ProjectResources {
    return this.props.resources;
  }
  get deleted(): boolean | undefined {
    return this.props.deleted;
  }
  get created_by(): string | undefined {
    return this.props.created_by;
  }
  get created_at(): Date | undefined {
    return this.props.created_at;
  }
  get updated_at(): Date | undefined {
    return this.props.updated_at;
  }
  get deleted_at(): Date | undefined {
    return this.props.deleted_at;
  }
  protected constructor(props: ProjectBaseProps, id: string) {
    super(props, id);
  }

  static create(props: ProjectBaseProps, id: string) {
    return new ProjectBase(props, id);
  }

  update(props: UpdateProjectBaseProps) {
    removeEmpty(props);
    if (props.label) this.label = props.label;
    if (props.description) this.description = props.description;
    if (props.location) this.location = props.location;
    if (props.optimizer_config) this.optimizer_config = props.optimizer_config;
    if (props.traffic_options) this.traffic_options = props.traffic_options;
    if (props.units) this.units = props.units;
    if (props.tasks_enabled !== undefined) this.tasks_enabled = props.tasks_enabled;
  }
}
